import stylesCss from "./download-link.module.css";

import { Flex } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const DownloadLink = ({
  children,
  href,
  original_name,
  show_icon = false,
  className = "",
  styles,
}) => {
  return (
    <a href={href} download={original_name} className={stylesCss.wrap}>
      <Flex gap={5} align="center">
        {children}
        <DownloadOutlined
          className={`${stylesCss.icon} ${show_icon && stylesCss.showIcon}`}
        />
      </Flex>
    </a>
  );
};

export default DownloadLink;
